// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.charging-title {
  font-size: 16px;
  font-weight: 500;
  margin-bottom: 16px;
  color: #333;
}

.charging-info {
  display: flex;
  flex-direction: column;
  gap: 12px;
}

.charging-row {
  background-color: white;
  border-radius: 8px;
  padding: 10px 14px;
  display: flex;
  justify-content: space-between;
  font-size: 14px;
  color: #555;
  box-shadow: 0 1px 3px rgba(0, 0, 0, 0.05);
  font-family: "Outfit";
}

.charging-value {
  font-weight: 600;
  color: #000;
}`, "",{"version":3,"sources":["webpack://./src/Pages/ChatBot/ChargingSessionCard/ChargingSessionCard.scss"],"names":[],"mappings":"AACE;EACE,eAAA;EACA,gBAAA;EACA,mBAAA;EACA,WAAA;AAAJ;;AAGE;EACE,aAAA;EACA,sBAAA;EACA,SAAA;AAAJ;;AAGE;EACE,uBAAA;EACA,kBAAA;EACA,kBAAA;EACA,aAAA;EACA,8BAAA;EACA,eAAA;EACA,WAAA;EACA,yCAAA;EACA,qBAAA;AAAJ;;AAGE;EACE,gBAAA;EACA,WAAA;AAAJ","sourcesContent":["  \n  .charging-title {\n    font-size: 16px;\n    font-weight: 500;\n    margin-bottom: 16px;\n    color: #333;\n  }\n  \n  .charging-info {\n    display: flex;\n    flex-direction: column;\n    gap: 12px;\n  }\n  \n  .charging-row {\n    background-color: white;\n    border-radius: 8px;\n    padding: 10px 14px;\n    display: flex;\n    justify-content: space-between;\n    font-size: 14px;\n    color: #555;\n    box-shadow: 0 1px 3px rgba(0, 0, 0, 0.05);\n    font-family: \"Outfit\";\n  }\n  \n  .charging-value {\n    font-weight: 600;\n    color: #000;\n  }\n  "],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
